// uid 默认返回 时间戳_6位随机字符，类型二返回随机字符

export const uid = (type: 1 | 2 = 1) => {
  const generateRandomValue = () => {
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    return Array.from(
      { length: 6 },
      () => characters[Math.floor(Math.random() * characters.length)],
    )?.join('');
  };
  return type === 1
    ? `${+new Date()}_${generateRandomValue()}`
    : generateRandomValue();
};

// 深拷贝
export const deepCopy = (obj) => {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  let copy = Array.isArray(obj) ? [] : {};

  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      copy[key] = deepCopy(obj[key]);
    }
  }

  return copy;
};

// 判断是否可以 parse
export const isValidJSON = (str) => {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
};

// 更新聊天框到底部
export const updateChatPosition = (id: string) => {
  setTimeout(() => {
    const target = document.getElementById(id);
    if (target) target.scrollTop = target.scrollHeight;
  }, 200);
};

// 微调聊天框滑动位置（点开 toolbar）
export const changeChatPosition = (id, height = 94) => {
  const target = document.getElementById(id);
  if (target) target.scrollTop = target.scrollTop + height;
};

// 取 domain
export const extractDomain = (url) => {
  // 移除 http/https 和 www
  let domain = url.replace(/^https?:\/\/(www\.)?/, '');
  return domain;
};

// 获取当前 url 的查询参数
export const getSearchParams = <T extends string | undefined = undefined>(
  key?: T,
): T extends string ? string | null : Record<string, string> => {
  const params = new URLSearchParams(window.location.search);

  if (key) {
    return params.get(key) as any;
  }

  return Object.fromEntries(params.entries()) as any;
};

// 获取 cookie 值
export const getCookie = (key) => {
  // 获取所有 Cookie
  const cookies = document.cookie.split('; ');
  // 遍历每个 Cookie
  for (let cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=');
    if (cookieName === key) {
      return decodeURIComponent(cookieValue); // 返回解码后的值
    }
  }
  return null; // 如果没有找到，返回 null
};

// 判断输入的 url 是否合法
export const validateUrl = (url) => {
  const regex =
    /^(?:(?:[a-z]+:)?\/\/)?(?:(?:[a-z0-9\-]+\.)+[a-z]{2,}|localhost)(?::\d{1,5})?(?:\/[^\s]*)?$/i;
  return regex.test(url);
};

// 判断输入 email 是否合法
export const validateEmail = (email) => {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
  return regex.test(email);
};

// 导出 excel
export const exportExcel = (
  data,
  fileName = 'export.xlsx',
  sheetName = 'Sheet1',
) => {
  function calculateColumnWidths(dataArray) {
    const colWidths = [];

    // 遍历每一列
    for (let col = 0; col < dataArray[0].length; col++) {
      let maxLength = 0;

      // 遍历每一行
      for (let row = 0; row < dataArray.length; row++) {
        const cellValue = dataArray[row][col] || '';
        const cellLength = cellValue.toString().length;

        // 中文等宽字符处理（每个中文字符算2个宽度）
        const chineseChars = (
          cellValue.toString().match(/[\u4e00-\u9fa5]/g) || []
        ).length;
        const adjustedLength = cellLength + chineseChars;

        if (adjustedLength > maxLength) {
          maxLength = adjustedLength;
        }
      }

      // 设置列宽（最小10，最大50，加2个字符的缓冲）
      colWidths.push({
        wch: Math.min(Math.max(maxLength + 2, 10), 100),
      });
    }

    return colWidths;
  }
  try {
    import('xlsx').then((XLSX) => {
      const wb = XLSX.utils.book_new();

      // 2. 准备表头和数据
      const headers = [
        'Event',
        'Page group',
        'Event description',
        'Event type',
        'Parameter',
        'Type',
        'Example value',
        'Parameter description', // 修正了原代码中的拼写错误
      ];

      // 3. 将数据转换为二维数组（确保数据格式统一）
      const dataArray = [headers, ...data];

      const ws = XLSX.utils.aoa_to_sheet(dataArray);

      // 1. 计算合并区域
      const merges = [];
      let currentEventStart = 1; // 从数据的第一行开始（跳过表头）

      for (let i = 1; i < dataArray.length; i++) {
        // 检测新事件开始（当前行第1列不为空，且不是第一行）
        if (dataArray[i][0] !== '' && i > currentEventStart) {
          const eventRowCount = i - currentEventStart;
          if (eventRowCount > 1) {
            // 合并第1-4列（索引0-3）
            for (let col = 0; col < 4; col++) {
              merges.push({
                s: { r: currentEventStart, c: col }, // 起始单元格
                e: { r: i - 1, c: col }, // 结束单元格
              });
            }
          }
          currentEventStart = i; // 更新新事件的起始行
        }
      }

      // 处理最后一个事件
      const lastEventRowCount = dataArray.length - currentEventStart;
      if (lastEventRowCount > 1) {
        for (let col = 0; col < 4; col++) {
          merges.push({
            s: { r: currentEventStart, c: col },
            e: { r: dataArray.length - 1, c: col },
          });
        }
      }

      // 2. 应用合并配置
      ws['!merges'] = merges;

      ws['!cols'] = calculateColumnWidths(dataArray);

      XLSX.utils.book_append_sheet(wb, ws, sheetName);

      XLSX.writeFile(wb, fileName);
    });
  } catch (error) {
    console.error('导出Excel失败:', error);
    throw error;
  }
};

// 判断是否是移动设备
export const isMobileDevice = () => {
  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    ) && window.innerWidth < 992
  );
};

// 获取主域名
export const getDomain = (url) => {
  const regex = /^(?:https?:\/\/)?(?:www\.)?([^\/]+)/;
  const match = url.match(regex);
  const mainDomain = match[1];
  return mainDomain;
};

// 平滑移动到指定锚点
export const scrollToSection = (sectionId: string) => {
  const element = document.getElementById(sectionId);
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }
};

// 格式化时间
export const transformer = (num: number) => {
  const seconds = Math.floor(num);

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  // 构建结果字符串
  let result = '';

  if (hours > 0) {
    result += `${hours}h `;
  }

  if (minutes > 0) {
    result += `${minutes}m `;
  }

  if (remainingSeconds > 0 || result === '') {
    result += `${remainingSeconds}s`;
  }

  // 去除末尾可能存在的空格
  return result.trim();
};

// 计算下次更新时间 Hour
export const calculateDaysUntilUpdate = (updateDay: number) => {
  const today = new Date();
  const currentDay = today.getDate();
  const currentMonth = today.getMonth();
  const currentYear = today.getFullYear();

  let nextUpdateDate;

  if (currentDay < updateDay) {
    nextUpdateDate = new Date(currentYear, currentMonth, updateDay);
  } else {
    nextUpdateDate = new Date(currentYear, currentMonth + 1, updateDay);
  }

  // 计算天数差
  const timeDiff = nextUpdateDate.getTime() - today.getTime();
  const daysDiff = Math.ceil(timeDiff / (1000 * 3600));

  return daysDiff;
};

// 后端字符串转为前端模板字符串
export const preprocessTextToMarkdown = (text: string) => {
  return (
    text
      // 移除所有的 [TODO] 标记
      .replace(/\[TODO\]/g, '')
      // 修复链接格式：将 [文本]URL 转换为标准 Markdown 链接 [文本](URL)
      .replace(/\[([^\]]+)\]https?:\/\/([^\s)]+)\)?/g, '[$1](https://$2)')
      // 将单个换行符转换为两个空格+换行（Markdown 软换行）
      .replace(/\n/g, '  \n')
      // 移除字符串开头和结尾的空白字符
      .trim()
  );
};

// 为 a 标签添加 新页签打开
export const addTargetBlankRegex = (str: string | undefined) => {
  if (!str) return '';

  return str.replace(
    /<a\s+href="([^"]*)">([^<]*)<\/a>/,
    '<a href="$1" target="_blank">$2</a>',
  );
};

export const downloadPdf = async (
  pdfUrl: string,
  callback: any,
  fileName = 'invoice.pdf',
) => {
  const link = document.createElement('a');
  link.href = pdfUrl;
  link.target = '_blank';
  link.download = fileName;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  callback?.();
};

// 转化为千分位数字
export const formatNumberToThousands = (num: number) => {
  return new Intl.NumberFormat('en-US').format(num);
};

// 跳转到锚点位置
export const handleToAnchor = (listId: string, id: string, offset?: number) => {
  const container = document.getElementById(listId);
  const target = document.getElementById(id);
  if (!container || !target) return; // 元素不存在则退出

  const targetTop = target.offsetTop + (offset || 0);

  container.scrollTo({
    top: targetTop,
    behavior: 'smooth', // 去掉这行则是瞬间跳转
  });
};

// 模拟点击 a 链接顶层打开新标签

export const openTopLevelNewTab = (url: string) => {
  if (!url) return;

  const link = document.createElement('a');
  link.href = url;

  link.target = '_blank';

  link.rel = 'opener';

  link.style.display = 'none';
  link.style.visibility = 'hidden';

  document.body.appendChild(link);

  try {
    link.click();
  } catch (error) {
    console.error('模拟点击失败，尝试直接打开:', error);
    window.open(url, '_blank', 'noopener=false');
  }

  document.body.removeChild(link);
};
